import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppBrand from '../components/AppBrand';

function RiskDisclaimerPage({ theme = 'dark' }) {
  const navigate = useNavigate();
  const darkMode = theme === 'dark';

  return (
    <div className={`legal-page-shell ${darkMode ? 'dark' : 'light'}`}>
      <div className="legal-page-container">
        <AppBrand theme={theme} />
        <div className="legal-page-topbar">
          <button
            type="button"
            className="back-link-btn"
            onClick={() => navigate('/')}
          >
            ← Back to App
          </button>
        </div>

        <div className="legal-page-card">
          <div className="legal-page-badge">Disclosure</div>
          <h1 className="legal-page-title">Risk Disclaimer / Educational Use Only</h1>

          <section className="legal-section">
            <h2>1. Educational and Informational Use Only</h2>
            <p>
              The StockVested app is provided for educational, informational, research,
              journaling, and performance-review purposes only.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Not Investment Advice</h2>
            <p>
              Nothing on the platform should be interpreted as personalized
              investment advice, financial advice, legal advice, tax advice, or a
              recommendation to buy, sell, or hold any security or financial
              instrument.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. No Guarantee of Results</h2>
            <p>
              Trading and investing involve substantial risk. Past performance does
              not guarantee future results. Analysis, commentary, AI-generated
              outputs, journal data, and performance summaries may be incomplete,
              delayed, incorrect, or unsuitable for your circumstances.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. You Are Responsible for Your Decisions</h2>
            <p>
              You are solely responsible for your trades, orders, portfolio
              decisions, risk management, and due diligence. You should evaluate all
              information independently before acting on it.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. High-Risk Nature of Trading</h2>
            <p>
              Securities trading, options trading, and active trading strategies may
              involve a high degree of risk, including the possible loss of principal
              and losses greater than initial expectations depending on the product or
              strategy used.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. No Fiduciary Relationship</h2>
            <p>
              Your use of the platform does not create a fiduciary, advisory,
              brokerage, or professional-client relationship.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Seek Professional Advice</h2>
            <p>
              If needed, consult a licensed financial professional, attorney,
              accountant, or tax adviser before making significant financial
              decisions.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default RiskDisclaimerPage;